/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Action constants for the location module
 */

export const BOX_CHANGED = '@@nzr/location/BOX_CHANGED'
export const CENTER_CHANGED = '@@nzr/location/CENTER_CHANGED'
export const ZOOM_CHANGED = '@@nzr/location/ZOOM_CHANGED'

export const CITY_NAME_CHANGED = '@@nzr/location/CITY_NAME_CHANGED'
export const CLEAR_CITY_NAME = '@@nzr/location/CLEAR_CITY_NAME'
export const HOOD_NAME_CHANGED = '@@nzr/location/HOOD_NAME_CHANGED'
export const CLEAR_HOOD_NAME = '@@nzr/location/CLEAR_HOOD_NAME'
export const STATE_NAME_CHANGED = '@@nzr/location/STATE_NAME_CHANGED'
export const CLEAR_STATE_NAME = '@@nzr/location/CLEAR_STATE_NAME'
export const URL_CHANGED = '@@nzr/location/URL_CHANGED'
